const Card = ({ as: Component = 'div', className = '', children, ...rest }) => {
  return (
    <Component
      className={[
        'rounded-2xl bg-white p-4 shadow-sm ring-1 ring-slate-200/60',
        className,
      ].join(' ')}
      {...rest}
    >
      {children}
    </Component>
  );
};

export default Card;